export const MONTHLY_INCOME_FORM_PREFIX = 'income';

export const RAC_MONTHLY_INCOME_FIELDS_NAMES = {
  TOTAL_INCOME: `${MONTHLY_INCOME_FORM_PREFIX}.totalIncome`,
  PRIMARY_MONTHLY_INCOME: `${MONTHLY_INCOME_FORM_PREFIX}.primaryMonthlyIncome`,
  PRIMARY_OTHER_MONTHLY_INCOME: `${MONTHLY_INCOME_FORM_PREFIX}.primaryOtherMonthlyIncome`,
  CO_APPLICANT_MONTHLY_INCOME: `${MONTHLY_INCOME_FORM_PREFIX}.coApplicantMonthlyIncome`,
  CO_APPLICANT_OTHER_MONTHLY_INCOME: `${MONTHLY_INCOME_FORM_PREFIX}.coApplicantOtherMonthlyIncome`,
};
